"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStruct = void 0;
const superstruct_1 = require("superstruct");
const ZoneTypesConfig_1 = require("../constants/ZoneTypesConfig");
function isStruct(value, struct, name) {
    if (value === undefined)
        return false;
    const [error] = (0, superstruct_1.validate)(value, struct);
    if (!error)
        return true;
    const valueJson = JSON.stringify(value, null, 4);
    ZoneTypesConfig_1.ZoneTypesConfig.logError(Error(`Invalid ${name}\n${error.message}\n${valueJson}`));
    return false;
}
exports.isStruct = isStruct;
//# sourceMappingURL=isStruct.js.map